@use 'styles/utils/variables' as *;

.loaderWrap {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  // Under the open side rail, which floats over the page: above it, a page's loader (its code, a map,
  // its data) took the pointer from under the rail, and the rail closed while the pointer was on it.
  z-index: $side-rail-z-index - 1;
  background: $background-color-secondary;
}

// A page whose code is still loading, right after the app loader.
.routeFallback {
  // The app loader (components/AppLoader) centres its dots in the window; this one follows it as the
  // page's code loads. Centred in the content area, the dots jumped right and down by half the rail
  // and half the header. The cover stays on the content area, the header stays visible.
  > * {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
